import styled from '@emotion/styled';
import { style } from '../../../../components/Shared/Style';

export default styled.span({
    fontSize: style.fontSize.milli,
    fontWeight: style.fontWeight.bold,
    textTransform: 'uppercase',
    color: style.colors.secondary
});
